import { useCallback } from "react";
import * as Actions from "../actions";
import * as LiveSessionStates from "../constants/liveSessionStates";
import { useDomainUseCase } from "./useDomainUseCase";

export const useLiveStreamActions = () => {
  const { execute } = useDomainUseCase();

  const getEntrypointsLives = useCallback(() => {
    execute({
      useCase: "GetListLiveStreamUseCase",
      params: {
        filter: {
          state: [
            LiveSessionStates.SCHEDULED,
            LiveSessionStates.READY,
            LiveSessionStates.STREAMING,
          ].join(","),
        },
      },
      getLoadingAction: Actions.getEntrypointsLives,
      getErrorAction: Actions.getEntrypointsLivesError,
      getSuccessAction: Actions.getEntrypointsLivesSuccess,
    });
  }, []);

  const getFeaturedLives = useCallback(() => {
    execute({
      useCase: "GetListLiveStreamUseCase",
      params: {
        filter: {
          state: LiveSessionStates.STREAMING,
        },
      },
      getLoadingAction: Actions.getFeaturedLives,
      getErrorAction: Actions.getFeaturedLivesError,
      getSuccessAction: Actions.getFeaturedLivesSuccess,
    });
  }, []);

  const getNextLives = useCallback(() => {
    execute({
      useCase: "GetListLiveStreamUseCase",
      params: {
        filter: {
          state: [LiveSessionStates.SCHEDULED, LiveSessionStates.READY].join(","),
        },
      },
      getLoadingAction: Actions.getNextLives,
      getErrorAction: Actions.getNextLivesError,
      getSuccessAction: Actions.getNextLivesSuccess,
    });
  }, []);

  return {
    getEntrypointsLives,
    getFeaturedLives,
    getNextLives,
  };
};
